module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reportMenu.edit":"Edit","reportMenu.delete":"Delete","reportMenu.clone":"Clone"}}')
  delete Component.options._Ctor
}
